import {Tooltip} from '@mui/material';
import { Info } from '@mui/icons-material';

export default () => <Tooltip title="These dates are actual hotel room nights that will be used as a template when individual rooms are added. Actual room availability per night will be added with each room and is the actual dates affecting what users can book.">
    <Info color="action" fontSize="small" sx={{ ml: 0.5 }} />
</Tooltip>